(function(global, factory) {
    typeof exports === "object" && typeof module !== "undefined" ? factory(exports, require("react"), require("@bloomreach/spa-sdk")) : typeof define === "function" && define.amd ? define([ "exports", "react", "@bloomreach/spa-sdk" ], factory) : (global = typeof globalThis !== "undefined" ? globalThis : global || self, 
    factory(global.BloomreachReactSdk = {}, global.React, global.BloomreachSpaSdk));
})(this, (function(exports, React, spaSdk) {
    "use strict";
    function _interopDefaultLegacy(e) {
        return e && typeof e === "object" && "default" in e ? e : {
            default: e
        };
    }
    var React__default = _interopDefaultLegacy(React);
    /**
   * The React Context holding the current brXM Component.
   */    const BrComponentContext = React__default["default"].createContext(undefined);
    function BrMeta({children, meta}) {
        var _a;
        const head = React.useRef(null);
        const tail = React.useRef(null);
        React.useEffect((() => {
            var _a;
            if (!((_a = head.current) === null || _a === void 0 ? void 0 : _a.nextSibling) || !tail.current) {
                return;
            }
            return meta.render(head.current.nextSibling, tail.current);
        }), [ meta, (_a = head.current) === null || _a === void 0 ? void 0 : _a.nextSibling, tail.current ]);
        return React__default["default"].createElement(React__default["default"].Fragment, null, meta.length > 0 && React__default["default"].createElement("span", {
            style: {
                display: "none"
            },
            ref: head
        }), children, meta.length > 0 && React__default["default"].createElement("span", {
            style: {
                display: "none"
            },
            ref: tail
        }));
    }
    /**
   * The React Context holding the current brXM Page.
   */    const BrPageContext = React__default["default"].createContext(undefined);
    const BrMappingContext = React__default["default"].createContext({});
    class BrNodeComponent extends React__default["default"].Component {
        getMapping() {
            return this.context[this.props.component.getName()];
        }
        render() {
            const mapping = this.getMapping();
            if (!mapping) {
                return this.props.children;
            }
            return React__default["default"].createElement(mapping, this.props);
        }
    }
    BrNodeComponent.contextType = BrMappingContext;
    function BrContainerBox(props) {
        return React__default["default"].createElement("div", {
            className: props.page.isPreview() ? "hst-container" : undefined
        }, React__default["default"].Children.map(props.children, (child => React__default["default"].createElement("div", {
            className: props.page.isPreview() ? "hst-container-item" : undefined
        }, child))));
    }
    function BrContainerInline(props) {
        return React__default["default"].createElement("div", {
            className: props.page.isPreview() ? "hst-container" : undefined
        }, React__default["default"].Children.map(props.children, (child => React__default["default"].createElement("span", {
            className: props.page.isPreview() ? "hst-container-item" : undefined
        }, child))));
    }
    function BrContainerNoMarkup(props) {
        return React__default["default"].createElement(React__default["default"].Fragment, null, props.children);
    }
    function BrContainerOrderedList(props) {
        return React__default["default"].createElement("ol", {
            className: props.page.isPreview() ? "hst-container" : undefined
        }, React__default["default"].Children.map(props.children, (child => React__default["default"].createElement("li", {
            className: props.page.isPreview() ? "hst-container-item" : undefined
        }, child))));
    }
    function BrContainerUnorderedList(props) {
        return React__default["default"].createElement("ul", {
            className: props.page.isPreview() ? "hst-container" : undefined
        }, React__default["default"].Children.map(props.children, (child => React__default["default"].createElement("li", {
            className: props.page.isPreview() ? "hst-container-item" : undefined
        }, child))));
    }
    function BrContainerItemUndefined(props) {
        return React__default["default"].createElement(React__default["default"].Fragment, null, 'Component "', props.component.getType(), '" is not defined.');
    }
    /**
   * The button component that opens for editing a content.
   */    class BrManageContentButton extends React__default["default"].Component {
        render() {
            var _a;
            return ((_a = this.context) === null || _a === void 0 ? void 0 : _a.isPreview()) ? React__default["default"].createElement(BrMeta, {
                meta: this.context.getButton(spaSdk.TYPE_MANAGE_CONTENT_BUTTON, this.props)
            }) : null;
        }
    }
    BrManageContentButton.contextType = BrPageContext;
    /**
   * The button component that opens a menu editor.
   */    class BrManageMenuButton extends React__default["default"].Component {
        render() {
            var _a;
            return ((_a = this.context) === null || _a === void 0 ? void 0 : _a.isPreview()) ? React__default["default"].createElement(BrMeta, {
                meta: this.context.getButton(spaSdk.TYPE_MANAGE_MENU_BUTTON, this.props.menu)
            }) : null;
        }
    }
    BrManageMenuButton.contextType = BrPageContext;
    class BrNodeContainer extends BrNodeComponent {
        getMapping() {
            const type = this.props.component.getType();
            if (type && type in this.context) {
                return this.context[type];
            }
            switch (type) {
              case spaSdk.TYPE_CONTAINER_INLINE:
                return BrContainerInline;

              case spaSdk.TYPE_CONTAINER_NO_MARKUP:
                return BrContainerNoMarkup;

              case spaSdk.TYPE_CONTAINER_ORDERED_LIST:
                return BrContainerOrderedList;

              case spaSdk.TYPE_CONTAINER_UNORDERED_LIST:
                return BrContainerUnorderedList;

              default:
                return BrContainerBox;
            }
        }
    }
    class BrNodeContainerItem extends BrNodeComponent {
        constructor(props) {
            super(props);
            this.onUpdate = this.onUpdate.bind(this);
        }
        componentDidMount() {
            this.props.component.on("update", this.onUpdate);
        }
        componentDidUpdate(prevProps) {
            if (this.props.component !== prevProps.component) {
                prevProps.component.off("update", this.onUpdate);
                this.props.component.on("update", this.onUpdate);
            }
        }
        componentWillUnmount() {
            this.props.component.off("update", this.onUpdate);
        }
        getMapping() {
            var _a;
            const type = this.props.component.getType();
            if (type && type in this.context) {
                return this.context[type];
            }
            return (_a = this.context[spaSdk.TYPE_CONTAINER_ITEM_UNDEFINED]) !== null && _a !== void 0 ? _a : BrContainerItemUndefined;
        }
        onUpdate() {
            this.forceUpdate((() => this.props.page.sync()));
        }
    }
    class BrNode extends React__default["default"].Component {
        renderNode() {
            if (React__default["default"].Children.count(this.props.children)) {
                return this.props.children;
            }
            const children = this.props.component.getChildren().map(((child, index) => React__default["default"].createElement(BrNode, {
                key: index,
                component: child
            })));
            if (spaSdk.isContainer(this.props.component)) {
                return React__default["default"].createElement(BrNodeContainer, {
                    component: this.props.component,
                    page: this.context
                }, children);
            }
            if (spaSdk.isContainerItem(this.props.component)) {
                return React__default["default"].createElement(BrNodeContainerItem, {
                    component: this.props.component,
                    page: this.context
                }, children);
            }
            return React__default["default"].createElement(BrNodeComponent, {
                component: this.props.component,
                page: this.context
            }, children);
        }
        render() {
            return React__default["default"].createElement(BrComponentContext.Provider, {
                value: this.props.component
            }, React__default["default"].createElement(BrMeta, {
                meta: this.props.component.getMeta()
            }, this.renderNode()));
        }
    }
    BrNode.contextType = BrPageContext;
    /**
   * The brXM component.
   */    class BrComponent extends React__default["default"].Component {
        getComponents() {
            if (!this.context) {
                return [];
            }
            if (!this.props.path) {
                return this.context.getChildren();
            }
            const component = this.context.getComponent(...this.props.path.split("/"));
            return component ? [ component ] : [];
        }
        renderComponents() {
            return this.getComponents().map(((component, index) => React__default["default"].createElement(BrNode, {
                key: index,
                component
            }, this.props.children)));
        }
        render() {
            return React__default["default"].createElement(React__default["default"].Fragment, null, this.renderComponents());
        }
    }
    BrComponent.contextType = BrComponentContext;
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P((function(resolve) {
                resolve(value);
            }));
        }
        return new (P || (P = Promise))((function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        }));
    }
    /**
   * @typedef {Object} BrPageProps
   * @property {Configuration} configuration The configuration of the SPA SDK.
   * @property {Object} mapping The brXM and React components mapping.
   * @property {Page | PageModel | undefined} page The pre-initialized page instance or prefetched page model.
   * Mostly this property should be used to transfer state from the server-side to the client-side.
   */
    /**
   * The brXM page.
   */    class BrPage extends React__default["default"].Component {
        /**
       * @param props {BrPageProps}
       */
        constructor(props) {
            super(props);
            this.state = {
                page: props.page && spaSdk.initialize(props.configuration, props.page)
            };
        }
        componentDidMount() {
            var _a;
            if (!this.props.page) {
                this.initialize();
            }
            (_a = this.state.page) === null || _a === void 0 ? void 0 : _a.sync();
        }
        componentDidUpdate(prevProps, prevState) {
            if (this.props.configuration !== prevProps.configuration || this.props.page !== prevProps.page) {
                this.destroy();
                this.initialize(this.props.page === prevProps.page);
            }
            if (this.state.page !== prevState.page) {
                this.forceUpdate((() => {
                    var _a;
                    return (_a = this.state.page) === null || _a === void 0 ? void 0 : _a.sync();
                }));
            }
        }
        componentWillUnmount() {
            this.destroy();
        }
        initialize(force = false) {
            return __awaiter(this, void 0, void 0, (function*() {
                const model = force ? undefined : this.props.page;
                try {
                    this.setState({
                        page: model ? spaSdk.initialize(this.props.configuration, model) : yield spaSdk.initialize(this.props.configuration)
                    });
                } catch (error) {
                    this.setState((() => {
                        throw error;
                    }));
                }
            }));
        }
        destroy() {
            if (!this.state.page) {
                return;
            }
            spaSdk.destroy(this.state.page);
        }
        render() {
            if (!this.state.page) {
                return null;
            }
            return React__default["default"].createElement(BrPageContext.Provider, {
                value: this.state.page
            }, React__default["default"].createElement(BrMappingContext.Provider, {
                value: this.props.mapping
            }, React__default["default"].createElement(BrNode, {
                component: this.state.page.getComponent()
            }, this.props.children)));
        }
    }
    exports.BrComponent = BrComponent;
    exports.BrComponentContext = BrComponentContext;
    exports.BrManageContentButton = BrManageContentButton;
    exports.BrManageMenuButton = BrManageMenuButton;
    exports.BrPage = BrPage;
    exports.BrPageContext = BrPageContext;
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
}));
//# sourceMappingURL=index.js.map
